const severities = {
  error: "error",
  info: "info",
  success: "success",
  warning: "warning",
};

export default severities;